import { PaymentStatus } from '@cpce/database/enums';
import { type BasePrestationTransactionFull, describeRecurrence } from '@cpce/shared';
import type { PaymentInstalmentRow } from '../columns/payment-instalments-columns';

export interface PaymentScheduleView {
  rows: PaymentInstalmentRow[];
  hasInstrumentNumber: boolean;
  recurrenceLabel: string;
  depositedCount: number;
}

export function toPaymentScheduleView(
  transaction: Pick<BasePrestationTransactionFull, 'paymentSchedule' | 'payments'>,
  hasInstrumentNumber: boolean
): PaymentScheduleView | undefined {
  const { paymentSchedule, payments } = transaction;
  if (!paymentSchedule) return undefined;

  const statusByInstalmentId = new Map(
    payments.map((payment) => [payment.instalmentId, payment.status])
  );
  const rows = paymentSchedule.instalments.map((instalment) => ({
    ...instalment,
    id: String(instalment.number),
    status: statusByInstalmentId.get(instalment.id),
  }));

  return {
    hasInstrumentNumber,
    recurrenceLabel: describeRecurrence({
      unit: paymentSchedule.intervalUnit,
      count: paymentSchedule.intervalCount,
      weekdays: paymentSchedule.weekdays,
    }),
    rows,
    depositedCount: rows.filter((row) => row.status === PaymentStatus.deposited).length,
  };
}
